import { isEmpty } from "lodash";
import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export default class NoteComponentController {
    public static $inject: string[] = ["mmModalService"];

    public site: IResponseWithLoading<ISite>;

    public isLoading: boolean;

    constructor(private readonly modalService: IModalService) {}

    public $onChanges() {
        if (this.site && this.site.data) {
            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }

    public editNotes(notes: string) {
        this.modalService.open<string, ISite>("mmEditSiteNotes", notes, this.site.data).subscribe(
            (editResponse) => {
                this.site.data.notes = editResponse;
            },
            (reason) => reason,
        );
    }

    public noContent(): boolean {
        return this.site.data && isEmpty(this.site.data.notes);
    }
}
